import React, { Fragment, useState, useRef } from 'react';
import { SwipeableDrawer, List, Popover } from '@mui/material';

import PopupMenuItem, { PopupMenuItemValueType } from './PopupMenuItem';

interface IPopMenuProps {
  children: React.ReactNode;
  menuItems: PopupMenuItemValueType[];
  isDrawer?: boolean;
}

const PopupMenu = (props: IPopMenuProps) => {
  const [open, setOpen] = useState(false);

  const handleToggle = () => setOpen(!open);
  const handleClose = () => setOpen(false);
  const handleOpen = () => setOpen(true);

  const anchorEl = useRef(null);

  const { children, menuItems, isDrawer } = props;
  return (
    <Fragment>
      <>
        <div ref={anchorEl} onClick={handleToggle}>
          {children}
        </div>
      </>

      {isDrawer ? (
        <SwipeableDrawer open={open} onClose={handleClose} onOpen={handleOpen}>
          <List>
            {menuItems.map((item, i) => {
              return <PopupMenuItem key={i} item={item} handleClose={handleClose} />;
            })}
          </List>
        </SwipeableDrawer>
      ) : (
        <Popover
          open={open}
          anchorEl={anchorEl.current}
          onClose={handleClose}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          transformOrigin={{ vertical: 'top', horizontal: 'right' }}
          PaperProps={{
            sx: {
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
              borderRadius: '8px',
              minWidth: '200px',
              mt: 1,
            },
          }}>
          <List sx={{ p: 0 }}>
            {menuItems.map((item, i) => {
              return <PopupMenuItem key={i} item={item} handleClose={handleClose} />;
            })}
          </List>
        </Popover>
      )}
    </Fragment>
  );
};

export default PopupMenu;
